import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// Store de l'interface utilisateur
export const useUIStore = create(
  devtools((set) => ({
    // État
    theme: 'light',
    sidebarOpen: true,
    notifications: [],
    loading: false,
    modal: {
      isOpen: false,
      content: null,
      props: {},
    },

    // Actions
    setTheme: (theme) => set({ theme }),
    
    toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
    
    setSidebarOpen: (isOpen) => set({ sidebarOpen: isOpen }),

    addNotification: (notification) =>
      set((state) => ({
        notifications: [
          ...state.notifications,
          { ...notification, id: Date.now() },
        ],
      })),

    removeNotification: (id) =>
      set((state) => ({
        notifications: state.notifications.filter((n) => n.id !== id),
      })),

    clearNotifications: () => set({ notifications: [] }),

    setLoading: (loading) => set({ loading }),

    openModal: (content, props = {}) =>
      set({ modal: { isOpen: true, content, props } }),

    closeModal: () =>
      set({ modal: { isOpen: false, content: null, props: {} } }),
  }))
)

export default useUIStore
